(ns app.front.view.group.reporting.config
  (:require [app.domain.group.model :as group-model]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.util :as futil]
            [app.front.view.group.admin.core :as core]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-event-fx ::set-assessment-reporting-config
  (fn [_ [_ group-id config]]
    {:comm/command {:command    :group/set-assessment-reporting-config
                    :data       (merge {:group-id group-id}
                                       (if (contains? (:group/features config) :group.feature/assessment-reporting)
                                         (update config
                                                 :group/features
                                                 set/intersection
                                                 group-model/assessment-features)
                                         ; Disable also automatic reporting if disabled overall
                                         (assoc config :group/features #{})))
                    :on-success [::core/save-config.success nil]}}))


(defn toggle [tr k *current-data disabled?]
  [:div.mb-4.mr-4
   (cc/toggle {:id         (str (name k) "-toggle")
               :label-text (tr [k])
               :labelA     (tr [:toggle/off])
               :labelB     (tr [:toggle/on])
               :disabled   (boolean disabled?)
               :on-toggle  #(swap! *current-data update :group/features (if % conj disj) k)
               :toggled    (contains? (:group/features @*current-data) k)})])


(defn select-partner
  [tr k *current-data disabled?]
  [:div.mb-4.mr-4
   [ui-select/select
    {:id           (str (name k) "-select")
     :required     true
     :allow-empty? false
     :label-text   (tr [k])
     :val->str     #(tr [%])
     :disabled     disabled?
     :value        (-> @*current-data k)
     :values       group-model/assessment-partners
     :on-change    (fn [partner]
                     (let [monthly? (group-model/partner-supports-monthly-reports? partner)]
                       (swap! *current-data
                              (fn [data]
                                (cond-> (assoc data k partner)
                                  monthly? (assoc :group/assessment-reporting-day-of-month group-model/assessment-reporting-default-date)
                                  (not monthly?) (dissoc :group/assessment-reporting-day-of-month))))))}]])

(defn select-reporting-date
  [tr k *current-data disabled?]
  (r/with-let [*invalid? (r/atom false)
               *value    (r/atom (get @*current-data k))]
    (let [e->v      (comp futil/parse-int futil/tval)
          on-change (fn [e]
                      (let [v (e->v e)]
                        (reset! *value v)
                        (when (group-model/valid-assessment-reporting-date? v)
                          (swap! *current-data assoc k v))))
          on-key-up (fn [e]
                      (let [invalid? (-> e e->v group-model/valid-assessment-reporting-date? not)]
                        (reset! *invalid? invalid?)))]
      [:div.mb-4.mr-4
       [ui/number-input {:id           (str (name k) "-schedule-date")
                         :label-text   (tr [:assessment-reporting/schedule-date])
                         :value        @*value
                         :disabled     disabled?
                         :invalid      @*invalid?
                         :invalid-text (when @*invalid?
                                         (tr [:assessment-reporting/schedule-date-invalid]
                                             [group-model/assessment-reporting-min-date
                                              group-model/assessment-reporting-max-date]))
                         :required     (not disabled?)
                         :step         1
                         :min          group-model/assessment-reporting-min-date
                         :max          group-model/assessment-reporting-max-date
                         :on-change    on-change
                         :on-key-up    on-key-up}]])))


(defn assessment-config [tr group]
  (r/with-let [initial-data  (merge {:group/features #{}}
                                    (select-keys group [:group/features
                                                        :group/assessment-reporting-id
                                                        :group/assessment-reporting-partner
                                                        :group/assessment-reporting-day-of-month]))
               *current-data (r/atom initial-data)]
    (let [reporting? (contains? (:group/features @*current-data) :group.feature/assessment-reporting)
          admin?     (<sub [:session/admin?])
          automatic? (and reporting?
                          (contains? (:group/features @*current-data) :group.feature/assessment-reporting-automatic))
          monthly?   (and automatic?
                          (not (group-model/send-assessment-immediately? @*current-data)))
          invalid?   (and reporting?
                          (or (str/blank? (:group/assessment-reporting-id @*current-data))
                              (str/blank? (:group/assessment-reporting-partner @*current-data))))]

      [:form.mt-8
       [:div.flex.flex-col
        [toggle tr :group.feature/assessment-reporting *current-data false]
        [:div.flex.flex-row
         [toggle tr :group.feature/assessment-reporting-automatic *current-data (not reporting?)]
         (when monthly?
           [select-reporting-date tr :group/assessment-reporting-day-of-month *current-data (not monthly?)])]
        (when admin?
          [select-partner tr :group/assessment-reporting-partner *current-data (not reporting?)])
        [:div.w-56
         [ui/text-input {:label-text  (tr [:group/assessment-reporting-id])
                         :placeholder (tr [:group/assessment-reporting-id-placeholder])
                         :disabled    (not reporting?)
                         :required    true
                         :value       (:group/assessment-reporting-id @*current-data)
                         :on-change   #(swap! *current-data assoc :group/assessment-reporting-id (futil/tval %))}]]]
       [:div.flex.justify-end.mt-3
        (cc/button {:kind     :tertiary
                    :disabled (= @*current-data initial-data)
                    :on-click #(reset! *current-data initial-data)}
                   (tr [:cancel]))
        (cc/button {:kind     :primary
                    :disabled (or (= @*current-data initial-data)
                                  invalid?)
                    :on-click #(>evt [::set-assessment-reporting-config
                                      (:db/id group)
                                      @*current-data])}
                   (tr [:save]))]])))
